import { IAppState } from 'models/store.models'

export const selectPixelId = (state: IAppState): string | undefined | null =>
  state.service.pixelId
